<template>
    <div id="steps-container">
      <div class="ui four column container centered grid fixed">
        <div class="row">
          <div class="ui fluid steps unstackable">
            <div class="active step column">
              <i class="in cart icon"></i>
              <div class="content mobile below hidden">
                <div class="title">Cart</div>
                <div class="description">{{lang.say('SHOPPING_FLOW_CART_DESC')}}</div>
              </div>
            </div>
            <div class="disabled step column">
              <i class="truck icon"></i>
              <div class="content mobile below hidden">
                <div class="title">Shipping</div>
                <div class="description">{{lang.say('SHOPPING_FLOW_SHIPPING_DESC')}}</div>
              </div>
            </div>
            <div class="disabled step column">
              <i class="payment icon"></i>
              <div class="content mobile below hidden">
                <div class="title">Billing</div>
                <div class="description">{{lang.say('SHOPPING_FLOW_PAYMENT_DESC')}}</div>
              </div>
            </div>
            <div class="disabled step column">
              <i class="info icon"></i>
              <div class="content mobile below hidden">
                <div class="title">Confirm</div>
                <div class="description">{{lang.say('SHOPPING_FLOW_CONFIRM_DESC')}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import lang from '../lang'; 
    
    export default {
        data() {
            return {
                lang
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// StepBar.vue?9b7ffba4